import { ChangeLogModal } from './ChangeLogModal';

export default ChangeLogModal;
